module.exports = __webpack_public_path__ + "img/crescendo-header.5620cde0.png";